const phone = "573203512202";

function preguntas(){
    var popup = document.getElementById("preguntas_popup");
    popup.classList.replace("cerrar","abrir");
}

function cerrarPreguntas(){
    var popup = document.getElementById("preguntas_popup");
    popup.classList.replace("abrir","cerrar");
}

function enviarPregunta(){
    var popup = document.getElementById("preguntas_popup");
    var form = popup.getElementsByTagName("form")[0];

    var nombre = form.getElementsByTagName("input")[0];
    var pregunta = form.getElementsByTagName("textarea")[0];

    if(nombre.value.length == 0 || pregunta.value.length == 0){
        alert("Debes llenar todos los campos!");
        return;
    }

    cerrarPreguntas();
    var url_encoded_msg = encodeURIComponent(`Hola! soy ${nombre.value} y tengo una pregunta: \n link del producto: ${window.location.href} \n ${pregunta.value}`);
    var mensaje = `https://api.whatsapp.com/send?phone=${phone}&text=${url_encoded_msg}`;
    nombre.value = "";
    pregunta.value = "";
    window.open(mensaje, '__blank');
}

function preguntaGenerica(){
    var pregunta = "Hola! Quisiera solicitar más información acerca de sus productos.";

    if(window.location.href.includes("/products/")){
        pregunta = pregunta + `\n link del producto: ${window.location.href}`;
    }

    var url_encoded_msg = encodeURIComponent(pregunta);
    var mensaje = `https://api.whatsapp.com/send?phone=${phone}&text=${url_encoded_msg}`;
    window.open(mensaje, '__blank');
}